import { Language } from "../store/ui"

import { Left, Right } from "purify-ts"
import { date, Codec } from "purify-ts/Codec"
import { format } from "date-fns"

export function dateCodec(language: Language): Codec<string> {
  const error = language === "nb_NO" ? nbError : nnError
  return Codec.custom<string>({
    decode: (input: unknown) => {
      const decodedDate = date.decode(input)

      return decodedDate.chain(inputDate => {
        const today = new Date()
        const newerThanToday = today.getTime() < inputDate.getTime()

        return !newerThanToday
          ? Right(formatDate(inputDate))
          : Left(error.notLaterThanToday)
      })
    },
    encode: input => input,
  })
}

interface DateErrors {
  notValid: string
  notLaterThanToday: string
}

const nbError: DateErrors = {
  notValid: "Dato er ikke gitt",
  notLaterThanToday: "Dato kan senest være dagens dato",
}

const nnError: DateErrors = {
  notValid: "Dato er ikke gitt",
  notLaterThanToday: "Dato kan senest være dagens dato",
}

export function formatDate(date: Date): string {
  return format(date, "yyyy-MM-dd")
}
